import React from 'react';
import 'moment-timezone';
import { MomentDate, MomentDateTime, MomentTime, MomentUnixDate, MomentUnixDateTime } from "../general/Moment";
export const GeneralTableUnixDateColumn = cell => {
  if (!cell) {
    return /*#__PURE__*/React.createElement("span", null, "Not Available");
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MomentUnixDate, null, cell));
};
export const GeneralTableUnixDateTimeColumn = cell => {
  if (!cell) {
    return /*#__PURE__*/React.createElement("span", null, "Not Available");
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MomentUnixDateTime, null, cell));
};
export const GeneralTableDateColumn = cell => {
  if (!cell) {
    return /*#__PURE__*/React.createElement("span", null, "Not Available");
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MomentDate, null, cell));
};
export const GeneralTableDateTimeColumn = cell => {
  if (!cell) {
    return /*#__PURE__*/React.createElement("span", null, "Not Available");
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MomentDateTime, null, cell));
};
export const GeneralTableTimeColumn = cell => {
  if (!cell) {
    return /*#__PURE__*/React.createElement("span", null, "Not Available");
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MomentTime, null, cell));
};